// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BarTitle_title__2Vf2e {\n  flex-grow: 1;\n}\n", "",{"version":3,"sources":["webpack://src/Navigation/Bar/BarTitle.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd","sourcesContent":[".title {\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "BarTitle_title__2Vf2e"
};
export default ___CSS_LOADER_EXPORT___;
